module.exports = __webpack_public_path__ + "img/course75_summary_unit_timelines.4fc2e6ff.png";